import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import useErrorModalStore from "../../store/error-modal/use-store";
var LazyErrorWarningModal = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ErrorWarningModal'));
  });
});
var ErrorWarningModalWrapper = function ErrorWarningModalWrapper(t0) {
  var $ = _c(3);
  var errorsToExclude = t0.errorsToExclude,
    warningsToInclude = t0.warningsToInclude;
  var error = useErrorModalStore(_temp);
  if (!error) {
    return null;
  }
  var t1;
  if ($[0] !== errorsToExclude || $[1] !== warningsToInclude) {
    t1 = /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, /*#__PURE__*/React.createElement(LazyErrorWarningModal, {
      errorsToExclude: errorsToExclude,
      warningsToInclude: warningsToInclude
    }));
    $[0] = errorsToExclude;
    $[1] = warningsToInclude;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
ErrorWarningModalWrapper.propTypes = {
  errorsToExclude: PropTypes.arrayOf(PropTypes.string),
  warningsToInclude: PropTypes.arrayOf(PropTypes.string)
};
export default ErrorWarningModalWrapper;
function _temp(state) {
  return state.error;
}